<template>
  <div class="container mainOrder" id="mainOrder">
    <left-aslide :activeNum="'1'"></left-aslide>
    <body-layout>
      <template slot="page-header">
        <filter-layout>
          <template slot="filter-left">订单详情</template>
        </filter-layout>
      </template>
      <template slot="ebs-content">
        <div class="elSteps">
          <render-step-jsx
            :dataDetail="dataDetail"
            :typeName="typeName"
          ></render-step-jsx>
        </div>
        <list-card-item :dataList="orderDatas" showDetail></list-card-item>
        <info :title="typeName + '企业信息'" :infoMap="infoMap.company"></info>
        <info :title="typeName + '项目信息'" :infoMap="infoMap.project"></info>
        <info :title="typeName + '担保机构信息'" :infoMap="infoMap.guarantors" v-if="isShowOrg"></info>
        <info :title="typeName + '订单邮寄信息'" :infoMap="infoMap.orderPost" v-if="isShowOrderPost"></info>
      </template>
    </body-layout>
  </div>
</template>

<script>
import Step from '@/components/CA/Step'
import { cloneDeep, merge } from 'lodash'
import { queryOrderDetail } from '@/api/order'
import { queryByFileId } from '@/api/upload'
import {
  ApplyType,
  CompanyFormat,
  ProjectFormat,
  filterData,
  GuarantorsInfoFormat,
  OrderPostInfoFormat
} from '@/shared/type'
import listCardItem from './components/listCardItem'
import Info from './components/info'
import { querySysValueData } from '@/api/comm'

const renderView = (targetRes, localRes, originRes) => {
  return targetRes?.reduce((per, cur) => {
    per[cur] = merge({ value: originRes[cur] }, localRes[cur])
    return per
  }, {})
}

const renderViewFile = (obj) => {
  const asyncFn = []
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const v = obj[key]
      if (v.type === 'file') {
        let cb = Promise.resolve({ key, fileName: '' })
        if (v.value?.includes('.')) {
          cb = Promise.resolve({ key, fileName: v.value })
        } else if (v.value) {
          cb = queryByFileId({ fileId: v.value }).then((res) => {
            if(res.data){
            const { fileName } = res.data
            return {
              key,
              fileName,
            }
          }
          })
        }
        asyncFn.push(cb)
      }
    }
  }
  return asyncFn
}

const renderViewDict = (obj) => {
  const asyncFn = []
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const v = obj[key]
      if(v.type === 'dict'){
      let cb
      cb = querySysValueData({
          key: v.dictCode
        }).then(res => {
          const et = res.data.find(item => item.valuesetKey === v.value)
          const valuesetValue = et?et.valuesetValue:v.value
          return {
              key,
              valuesetValue,
            }
        })
        asyncFn.push(cb)
      }
    }
  }
  return asyncFn
}

const renderStepJsx = {
  props: {
    dataDetail: {
      type: Object,
      default: () => ({}),
    },
    typeName: String,
  },
  computed: {
    res() {
      const { applyType, isExectronic, guaranteeApplyStatus, apiId, isNeedCommitment } = this.dataDetail
      let r = filterData(applyType, isExectronic, guaranteeApplyStatus, apiId, isNeedCommitment)
      return r
    },
    active() {
      const res = cloneDeep(this.res)
      const index = Object.values(res || {}).findIndex((k) =>
        k.k.includes(this.dataDetail?.guaranteeApplyStatus)
      )
      const r = index < 0 ? 0 : index + 1
      return r
    },
  },
  render() {
    const { active, typeName, dataDetail, res } = this
    const jsx = Object.values(res || {}).map((item, index) => {
      const i = index + 2
      const description = item.k.includes('3000')
        ? '驳回原因：' + dataDetail.partnerRejectReason:''
      const uri = item.k.includes('4000')||item.k.includes('500')?dataDetail.commitmentPdfSginId:''
      return {
        icon: i,
        span: item.n,
        status: (active > i - 1) || (active == i-1 &&  ['3000', '5000'].includes(dataDetail.guaranteeApplyStatus))
         ? 'finish' : active == i-1 ? 'active' : 'wait',
        description,
        uri
      }
    })

    jsx.unshift({
      icon: 1,
      span: typeName + '信息填写',
      description: dataDetail.createTime,
      status: 'finish',
      uri:'',
    })

    return <Step arr={jsx} />
  },
}

export default {
  name: 'orderDetail',
  components: {
    listCardItem,
    Info,
    renderStepJsx,
  },
  props: {
    orderID: String,
  },
  data() {
    return {
      dataDetail: {},
      infoMap: {},
      isShowOrg:false,
      isShowOrderPost:false
    }
  },
  computed: {
    typeData() {
      const { dataDetail } = this
      const t = dataDetail.applyType
      let typeData
      // 电子银行保函特殊处理
      if (dataDetail.isExectronic === '1' && dataDetail.applyType === '8000') {
        typeData = dataDetail.apiId === 'ahyd' || dataDetail.apiId === 'gzyh'
          ? ApplyType[t][dataDetail.apiId]
          : ApplyType[t].exectronicBank
      } else {
        typeData = ApplyType[t]
        if (this.isHlj && dataDetail.applyType === '9600' && dataDetail.basicPay === '1') {
          typeData.company.splice(typeData.company.length - 1, 0, 'bankCardNo', 'bankCardName')
        }
      }
      const res = cloneDeep(typeData)
      // 保函申请书不存在时不展示该字段
      if (!dataDetail.guaranteeApplyPdfId && res.project) {
        res.project = res.project.filter((key) => key !== 'guaranteeApplyPdfId')
      }
      return res
    },
    typeName() {
      const { dataDetail } = this
      const { typeData } = this
      return dataDetail.isExectronic === '1'?typeData?.n_dz :typeData?.n || ''
    },
    orderDatas() {
      const { dataDetail, typeName } = this
      return {
        ...dataDetail,
        guaranteeName: typeName,
      }
    },
    isHlj() {
      return this.$store.state.letter.isHlj
    }
  },
  methods: {
    getDataDetail() {
      return queryOrderDetail(this.orderID).then((v) => {
        this.dataDetail = v.data
      })
    },
    async renderInfoMap() {
      const { dataDetail, typeData } = this
      this.isShowOrg = dataDetail.isAgencyFees
      this.isShowOrderPost = dataDetail.guaranteeApplyStatus === '5000' && (dataDetail.applyType === '7000'|| dataDetail.applyType === '8000') && dataDetail.isExectronic === '0'

      const company = cloneDeep(CompanyFormat)
      const project = cloneDeep(ProjectFormat)
      const guarantors = cloneDeep(GuarantorsInfoFormat)
      const orderPost = cloneDeep(OrderPostInfoFormat)
      const companyView = renderView(typeData?.company, company, dataDetail)
      const projectView = renderView(typeData?.project, project, dataDetail)
      const guarantorsView = renderView(typeData?.guarantors, guarantors, dataDetail)
      const orderPostView = renderView(typeData?.orderPost, orderPost, dataDetail)
      const asyncFileNameFn = renderViewFile(
        merge({}, companyView, projectView, guarantorsView,orderPostView)
      )
      const asyncDictNameFn = renderViewDict(
        merge({}, companyView, projectView, guarantorsView,orderPostView)
      )
      await Promise.all(asyncFileNameFn)
        .then((file) => {
          file.forEach((f) => {
            companyView && companyView[f.key] && (companyView[f.key].format = f.fileName)
            projectView && projectView[f.key] && (projectView[f.key].format = f.fileName)
            orderPostView && orderPostView[f.key] && (orderPostView[f.key].format = f.fileName)
          })
        })
        .catch((e) => {
          console.log(e)
        })
        await Promise.all(asyncDictNameFn)
        .then((dict) => {
          dict.forEach((f) => {
            companyView && companyView[f.key] && (companyView[f.key].value = f.valuesetValue)
            projectView && projectView[f.key] && (projectView[f.key].value = f.valuesetValue)
            orderPostView && orderPostView[f.key] && (orderPostView[f.key].value = f.valuesetValue)
          })
        })
        .catch((e) => {
          console.log(e)
        })
      const map = {
        company: companyView,
        project: projectView,
        guarantors: guarantorsView,
        orderPost: orderPostView
      }
      this.infoMap = map
    },
  },
  mounted() {
    this.getDataDetail().then(this.renderInfoMap)
  },
}
</script>

<style scoped lang="less">
.container {
  display: flex;
  padding-top: 30px;
  overflow: hidden;
}
.elSteps {
  padding: 20px 0;
}
.boxitem header {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  background-color: #eff6fa;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.baohanIcon {
  width: 66px;
  height: 66px;
}
.orderStatus {
  margin-right: 30px;
}
.boxitem {
  background-color: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 10px;
  /*height: 160px;*/
}
.orderAmount {
  display: inline-block;
  float: right;
}
.amoutWeight {
  color: #eb3941;
  font-weight: 700;
}
.lineSpan {
  padding: 20px;
}
.projectInfo {
  border-left: 1px solid #dbdbdb;
  border-right: 1px solid #dbdbdb;
  padding: 2% 5% !important;
}
/deep/ .btns .el-button:nth-of-type(odd) {
  margin-left: 0 !important;
}
/deep/ .btns .el-button {
  margin-bottom: 10px;
  padding: 6px 10px !important;
  width: 47%;
}
/deep/ .btns .el-button span {
  font-size: 12px !important;
}
.btns {
  /*padding-left: 15%;*/
  position: absolute;
  /*right: 10%;*/
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}
.personInfo {
  margin-left: 20px;
}
.projectInfo div {
  margin-bottom: 20px;
}
.rowItem {
  height: 110px;
}
.rowItem .el-col {
  height: 100%;
}
.btnItem {
  position: relative;
}
.orderInfo {
  border: 1px solid #dbdbdb;
  border-radius: 10px;
  margin: 20px 0;
}
.orderInfo /deep/ .el-button {
  width: 100%;
}
.orderInfo /deep/ .el-button span {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
/deep/ .ebs-content {
  padding: 0 20px;
}
</style>
